// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");
var $ = require("jquery");

var url = "https://projects.seattletimes.com/election-data/json/results.json"

var resultsContainer = document.querySelector(".races");

var fi = (condition, value) => condition ? value : "";

var raceTemplate = data => `
  <section class="race">
    <h3>${data.title}</h3>
    <p class="race__description">${data.race}</p>
    <ul class="results">
      ${data.candidates.map(c => `
      <li>
        <span class="name ${c.called ? "called" : ""}">${c.candidate}</span>
        <span class="divider"></span>
        <span class="result">${(c.vote_percentage*1).toLocaleString().replace(/1.0+$/, "")}%</span>
      `).join("")}
    </ul>
  </section>
`;

var callback = function(table) {
  var races = {};
  table.forEach(function(el) {
    if (!races[el.race]) races[el.race] = {
      race: el.race,
      title: el.title,
      total: 0,
      candidates: [],
    };
    var race = races[el.race];
    race.candidates.push(el);    
    race.total += el.vote_percentage * 1;
  });
  var innerHTML = "";
  for (var r in races) {
    races[r].candidates.sort((a, b) => b.vote_percentage - a.vote_percentage);
    innerHTML += raceTemplate(races[r]);
  }
  resultsContainer.innerHTML = innerHTML;
}

$.getJSON(url, function(data) {
  callback(data);
})